@if (isCellVisible()) {
  <ng-content></ng-content>
}
